import React, { Component } from 'react';
import { connect } from 'react-redux';

import { message } from 'antd';
import { querySaveCustom } from '@api/crm/crm';
import FormCustom from './FormStage';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleAdd = params => {
    querySaveCustom(params).then(res => {
      if (res.code === 200) {
        message.success(res.message);
      }
    });
  };

  render() {
    return (
      <div>
        <FormCustom handleSubmit={this.handleAdd} />
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/department/stage/PageEdit.js